enum TicketQueues {
    Dashboard = "Dashboard",
    AdvancedSearch = "",
    WaitingForCustomer = "WaitingForCustomer",
    WaitingForSimec = "WaitingForSimec",
    Open = "Open",
    Mine = "Mine",
    Unassigned = "Unassigned"
}

export default TicketQueues;